<template>
  <div class="footer__select">
    <label :for="id" class="is-sr-only">{{ selectLabelText }}</label>
    <select :id="id" name="brands" class="select-css" ref="mainSelect" @change="onChange($event)" target="_blank">
      <option disabled selected="selected" v-if="showSelectLabelTextOption">
        {{ selectLabelText }}
      </option>
      <option v-for="(item, index) in dropdownOptions"
              :value="item.url"
              :key="index">{{ item.option }}
      </option>
    </select>
    <img :data-src="dropdownIconUrl" :alt="dropdownIconAlternativeText" class="lazyload arrow" />
  </div>
</template>
<script>
  import kebab from 'lodash.kebabcase';

  export default {
    name: 'select-open-url',
    props: {
      showSelectLabelTextOption: { type: Boolean, required: true, default: false },
      selectLabelText: { type: String, required: true },
      dropdownOptions: { type: Array, required: true },
      dropdownIconUrl: { type: String, required: true },
      dropdownIconAlternativeText: { type: String, required: true },
    },
    data() {
      return {
        isValidUrl: false,
        id: ''
      };
    },
    mounted() {
      this.id = kebab(this.selectLabelText);
    },
    methods: {
      onChange(event) {
        if (event.target.value !== '') {
          this.isValidUrl = true;
          window.location.assign(event.target.value);
        }
      }
    }
  };
</script>
